import React from "react";
import "style/PlanItems.scss";

import Tooltip from "@mui/material/Tooltip";

import { default as SvgPlanItemTrue } from "assets/SvgPlanItemTrue.svg";
import { default as SvgPlanItemFalse } from "assets/SvgPlanItemFalse.svg";

import { default as SvgViewFeaturesClose } from "assets/SvgViewFeaturesClose.svg";
import { default as SvgViewFeaturesOpen } from "assets/SvgViewFeaturesOpen.svg";
import { default as SvgInformation } from "assets/SvgInformation.svg";

interface Props {
  planDescription: any;

  id: number;
  name: string;
  description: string;
  provides: [];
  cost_ones: string;
  cost_monthly: string;
  on_sale: string;
  start_trial_url: string;
  windowWidth: number;
  planUrlCounter: string;
  planInfoText: any;
}

interface State {
  viewFeature: boolean;
  showTooltip: boolean;
  planInfo: boolean;
}

class PlanItems extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      viewFeature: true,
      showTooltip: false,
      planInfo: false,
    };
  }

  componentDidMount() {}

  render() {
    return (
      <div className="plan-items-main">
        <p className="plan-items-name">{this.props.name}</p>
        <p className="plan-items-description">
          <b>{this.props.description}</b>
        </p>
        {this.props.windowWidth > 600 ? (
          <>
            {this.props.provides &&
              this.props.provides.map((provide: string, index: number) => {
                return (
                  <div
                    key={this.props.id + index}
                    className="plan-item-provides"
                  >
                    <hr />
                    <table>
                      <tbody>
                        <tr>
                          {provide === "true" ? (
                            <td>
                              <p>
                                <img
                                  src={SvgPlanItemTrue}
                                  className="svgPlanItemTrue"
                                  alt="svg plan True"
                                />
                              </p>
                            </td>
                          ) : provide === "false" ? (
                            <td>
                              <img
                                src={SvgPlanItemFalse}
                                className="svgPlanItemTrue"
                                alt="svg plan false"
                              />
                            </td>
                          ) : (
                            <>
                              <td>
                                <p>{provide}</p>
                              </td>
                            </>
                          )}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                );
              })}
            <a
              href={this.props.planUrlCounter}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="plan-items-start-trial">
                <span>{this.props.planInfoText[0]}</span>
              </div>
            </a>
            <div>
              <div className="plan-price-up">
                <p>{this.props.cost_ones}</p>
                <p>{this.props.planInfoText[1]}</p>
              </div>
              <div style={{ padding: "0.5px" }}></div>
              <div className="plan-price-down">
                <p>
                  <span>{this.props.cost_monthly}</span> /{" "}
                  {this.props.planInfoText[2]}
                </p>
                <p>
                  {this.props.planInfoText[3]} {this.props.on_sale}
                </p>
              </div>
            </div>
          </>
        ) : (
          <>
            <div>
              <div className="plan-price-up">
                <p>{this.props.cost_ones}</p>
                <p>{this.props.planInfoText[1]}</p>
              </div>
              <div className="plan-price-down">
                <p>
                  <span>
                    <b>{this.props.cost_monthly}</b>
                  </span>{" "}
                  / {this.props.planInfoText[2]}
                </p>
                <p>
                  {this.props.planInfoText[3]} {this.props.on_sale}
                </p>
              </div>
            </div>
            <a
              href={this.props.planUrlCounter}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="plan-items-start-trial">
                <span>{this.props.planInfoText[0]}</span>
              </div>
            </a>
            <hr />
            <div className="plan-items-view-features">
              <button
                className="plan-items-view-features-btn"
                onClick={() => {
                  this.setState({ viewFeature: !this.state.viewFeature });
                }}
              >
                <span>{this.props.planInfoText[4]}</span>
                <span>
                  {this.state.viewFeature ? (
                    <img src={SvgViewFeaturesOpen} alt="view features" />
                  ) : (
                    <img src={SvgViewFeaturesClose} alt="view features" />
                  )}
                </span>
              </button>
            </div>
            <hr />

            {!this.state.viewFeature ? (
              <>
                {this.props.provides &&
                  this.props.provides.map((provide: any, index: number) => {
                    return (
                      <div
                        key={this.props.id + index}
                        className="plan-item-provides-features"
                      >
                        <table>
                          <tbody>
                            <tr>
                              {provide === "true" ? (
                                <td>
                                  <div className="plan-items-left">
                                    <p className="plan-item-description-items">
                                      {
                                        this.props.planDescription[index]
                                          .description
                                      }
                                    </p>
                                    <img
                                      src={SvgPlanItemTrue}
                                      className="svgPlanItemTrue"
                                      alt="svg Plan True"
                                    />
                                  </div>
                                  <div className="plan-items-right">
                                    {this.props.planDescription[index].info !==
                                    "undefined" ? (
                                      <Tooltip
                                        title={
                                          this.props.planDescription[index].info
                                        }
                                        placement="right-start"
                                        open={this.state.planInfo}
                                        onClick={() => {
                                          this.state.planInfo === false
                                            ? this.setState({ planInfo: true })
                                            : this.setState({
                                                planInfo: false,
                                              });
                                        }}
                                      >
                                        <img
                                          className="plan-description-table-icon"
                                          src={SvgInformation}
                                          alt="Information"
                                        />
                                      </Tooltip>
                                    ) : null}
                                  </div>
                                </td>
                              ) : provide === "false" ? (
                                <td>
                                  <div className="plan-items-left">
                                    <p className="plan-item-description-items">
                                      {
                                        this.props.planDescription[index]
                                          .description
                                      }
                                    </p>
                                    <img
                                      src={SvgPlanItemFalse}
                                      className="svgPlanItemTrue"
                                      alt="svg Plan True"
                                    />
                                  </div>
                                  <div className="plan-items-right">
                                    {this.props.planDescription[index].info !==
                                    "undefined" ? (
                                      <Tooltip
                                        title={
                                          this.props.planDescription[index].info
                                        }
                                        placement="right-start"
                                        open={this.state.planInfo}
                                        onClick={() => {
                                          this.state.planInfo === false
                                            ? this.setState({ planInfo: true })
                                            : this.setState({
                                                planInfo: false,
                                              });
                                        }}
                                      >
                                        <img
                                          className="plan-description-table-icon"
                                          src={SvgInformation}
                                          alt="Information"
                                        />
                                      </Tooltip>
                                    ) : null}
                                  </div>
                                </td>
                              ) : (
                                <>
                                  <td>
                                    <div className="plan-items-left">
                                      <p className="plan-item-description-items">
                                        {
                                          this.props.planDescription[index]
                                            .description
                                        }
                                      </p>
                                      <p>{provide}</p>
                                    </div>
                                    <div className="plan-items-right">
                                      {this.props.planDescription[index]
                                        .info !== "undefined" ? (
                                        <Tooltip
                                          title={
                                            this.props.planDescription[index]
                                              .info
                                          }
                                          placement="right-start"
                                          open={this.state.planInfo}
                                          onClick={() => {
                                            this.state.planInfo === false
                                              ? this.setState({
                                                  planInfo: true,
                                                })
                                              : this.setState({
                                                  planInfo: false,
                                                });
                                          }}
                                        >
                                          <img
                                            className="plan-description-table-icon"
                                            src={SvgInformation}
                                            alt="Information"
                                          />
                                        </Tooltip>
                                      ) : null}
                                    </div>
                                  </td>
                                </>
                              )}
                            </tr>
                          </tbody>
                        </table>
                        <hr />
                      </div>
                    );
                  })}
              </>
            ) : null}
          </>
        )}
      </div>
    );
  }
}

export default PlanItems;
